import { ChangeEvent } from 'react';

import { CircularProgress, TextField, useTheme } from '@material-ui/core';

import { RiCheckboxCircleFill as CheckCircleIcon } from '@remixicon/react';

import { FormFieldsBox } from '@spotify/confidence-core-react';

import {
  useAccountDetailsContext,
  useWorkspaceNameFieldsContext,
} from './CreateAccountFormProvider';

export const WorkspaceNameFields = () => {
  const theme = useTheme();
  const { accountDetails } = useAccountDetailsContext();
  const {
    handleDisplayNameChange,
    handleDisplayNameBlur,
    validDisplayName,
    helperText,
    loginIdAvailable,
    loginIdError,
    loginIdConfirmedAvailable,
    isCheckingAvailability,
  } = useWorkspaceNameFieldsContext();

  return (
    <FormFieldsBox spacing={2}>
      <TextField
        variant="outlined"
        label="Workspace name"
        placeholder="For example My Company"
        value={accountDetails.displayName}
        helperText={helperText}
        error={!validDisplayName || !loginIdAvailable || !!loginIdError}
        required
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          handleDisplayNameChange(e.target.value)
        }
        onBlur={handleDisplayNameBlur}
        InputProps={{
          endAdornment: isCheckingAvailability ? (
            <CircularProgress size="1rem" />
          ) : (
            loginIdConfirmedAvailable && (
              <CheckCircleIcon size={20} color={theme.palette.success.main} />
            )
          ),
        }}
        fullWidth
      />
    </FormFieldsBox>
  );
};
